module.exports = __webpack_public_path__ + "static/StickerA2020-d528b5ce8aa980b8a807615cbe4a4559.jpg";